import React from "react";

/**
 * A cell component that removes underscores from text and capitalizes the first letter.
 */
export const NormalizeCell = ({ getValue, value }) => {
  const raw = value ?? getValue?.();

  if (raw == null) return null;

  const normalized = String(raw)
    .replace(/_/g, " ")
    .replace(/^\w/, (c) => c.toUpperCase());

  return <span>{normalized}</span>;
};

export default NormalizeCell;
